module.exports = __webpack_public_path__ + "img/logo-tl-light.1f666d06.svg";